// extracted by mini-css-extract-plugin
export default {"queuesSelect_wrap":"SelectQueues_queuesSelect_wrap__unjrS","queuesInput_wrap":"SelectQueues_queuesInput_wrap__1-l0p","checkboxInput_wrap":"SelectQueues_checkboxInput_wrap__bgbDk"};